var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOverview01 = function SvgOverview01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "overview-01_svg2__a",
    x1: 42.43,
    x2: 137.57,
    y1: 191.12,
    y2: -4.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overview-01_svg2__a",
    id: "overview-01_svg2__b",
    x1: 11.34,
    x2: 106.48,
    y1: 176.02,
    y2: -19.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overview-01_svg2__a",
    id: "overview-01_svg2__c",
    x1: 18.28,
    x2: 113.42,
    y1: 179.39,
    y2: -16.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overview-01_svg2__a",
    id: "overview-01_svg2__d",
    x1: 31,
    x2: 126.14,
    y1: 185.54,
    y2: -10.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overview-01_svg2__a",
    id: "overview-01_svg2__e",
    x1: 43.7,
    x2: 138.85,
    y1: 191.74,
    y2: -4.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overview-01_svg2__a",
    id: "overview-01_svg2__f",
    x1: 4.4,
    x2: 99.55,
    y1: 172.66,
    y2: -23.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#overview-01_svg2__a",
    id: "overview-01_svg2__g",
    x1: 111.53,
    x2: 206.67,
    y1: 224.69,
    y2: 28.81
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M153.57 178.57c-1.97 0-3.57 1.6-3.57 3.57 0 6-4.72 10.71-10.71 10.71H17.86c-6 0-10.71-4.72-10.71-10.71V50h28.57c7.85 0 14.29-6.43 14.29-14.29V7.23c29.67-.18 59.54-.08 89.29-.08 6 0 10.71 4.72 10.71 10.71v60.71c0 1.97 1.6 3.57 3.57 3.57s3.57-1.6 3.57-3.57V17.86c0-9.83-8.03-17.86-17.86-17.86H50.81c-3.25 0-6.32 1.32-8.59 3.54L3.6 41.35C1.25 43.65 0 46.79 0 50v132.14C0 191.97 8.03 200 17.86 200h121.43c9.83 0 17.86-8.03 17.86-17.86 0-1.97-1.6-3.57-3.57-3.57ZM42.86 12.91v22.8c0 4.02-3.12 7.14-7.14 7.14H12.27L42.86 12.9Z",
    style: {
      fill: "url(#overview-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 100h50c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57H25c-1.97 0-3.57 1.6-3.57 3.57S23.03 100 25 100",
    style: {
      fill: "url(#overview-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 125h42.86c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57H25c-1.97 0-3.57 1.6-3.57 3.57S23.03 125 25 125",
    style: {
      fill: "url(#overview-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 150h50c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57H25c-1.97 0-3.57 1.6-3.57 3.57S23.03 150 25 150",
    style: {
      fill: "url(#overview-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 175h57.14c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57H25c-1.97 0-3.57 1.6-3.57 3.57S23.03 175 25 175",
    style: {
      fill: "url(#overview-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.14 67.86H25c-1.97 0-3.57 1.6-3.57 3.57S23.03 75 25 75h57.14c1.97 0 3.57-1.6 3.57-3.57s-1.6-3.57-3.57-3.57",
    style: {
      fill: "url(#overview-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.95 193.9-36.24-36.24c6.33-7.47 10.16-17.11 10.16-27.64 0-23.63-19.23-42.86-42.86-42.86s-42.86 19.23-42.86 42.86 19.23 42.86 42.86 42.86c10.53 0 20.17-3.84 27.64-10.16l36.24 36.24a3.58 3.58 0 0 0 5.05 0 3.58 3.58 0 0 0 0-5.05Zm-68.93-28.17c-19.77 0-35.71-15.95-35.71-35.71s15.95-35.71 35.71-35.71 35.71 15.95 35.71 35.71-15.95 35.71-35.71 35.71",
    style: {
      fill: "url(#overview-01_svg2__g)"
    }
  }));
};
export default SvgOverview01;